import { render } from "./UsersInviteOverlay.vue?vue&type=template&id=ef6a5f5c&scoped=true&ts=true"
import script from "./UsersInviteOverlay.vue?vue&type=script&lang=ts"
export * from "./UsersInviteOverlay.vue?vue&type=script&lang=ts"

import "./UsersInviteOverlay.vue?vue&type=style&index=0&id=ef6a5f5c&lang=scss&scoped=true"

import exportComponent from "/Users/alexanderclaas/Documents/Epic AI/ChatCaptain/chatcaptain-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef6a5f5c"]])

export default __exports__